import { RouteConfig } from 'vue-router'

const WxAccountBind = () => import('../../views/tzy/Regist/StuAccountRegist.vue')

export const wxAccountBindRoute: RouteConfig = {
  path: '/wxpublic-stu/wechat-stu-account-bind',
  name: 'wechat_stu_account_bind',
  props: (route) => ({ ...route.query }),
  component: WxAccountBind,
  meta: {
    title: '登记账号',
  },
}

export default [wxAccountBindRoute]
